export const INSTRUCTOR_CREATE = 'INSTRUCTOR_CREATE'
export const UPDATE_ATTENDANCE = 'UPDATE_ATTENDANCE'
export const UPDATE_PAYMENT_RECEIPT_STATUS = 'UPDATE_PAYMENT_RECEIPT_STATUS'
export const UPDATE_GRADE = 'UPDATE_GRADE'
export const GET_COURSE_FULL_DETAILS = 'GET_COURSE_FULL_DETAILS'
export const COURSE_FULL_DETAILS_UPDATED = 'COURSE_FULL_DETAILS_UPDATED'
export const START_COURSE = 'START_COURSE'
export const END_COURSE = 'END_COURSE'

const initialState = {
  courses: {},
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case COURSE_FULL_DETAILS_UPDATED:
      //console.log('COURSE_FULL_DETAILS_UPDATED', action)
      const { courseId, course, students } = action.data

      return {
        ...state,
        courses: {
          ...state.courses,
          [courseId]: {
            course,
            students,
          },
        },
      }
      break
    default:
      return state
  }
}

export const createInstructor = data => {
  //console.log('create instructor ', data)
  return {
    type: INSTRUCTOR_CREATE,
    data: data,
  }
}

export const updateAttendance = (courseId, studentId, hasAttended) => {
  //console.log('updateAttendance ', courseId, studentId, hasAttended)
  return {
    type: UPDATE_ATTENDANCE,
    data: { courseId, studentId, hasAttended },
  }
}

export const updatePaymentReceiptStatus = (courseId, studentId, hasReceipt) => {
  //console.log('updatePaymentReceiptStatus ', courseId, studentId, hasReceipt)
  return {
    type: UPDATE_PAYMENT_RECEIPT_STATUS,
    data: { courseId, studentId, hasReceipt },
  }
}

export const updateGrade = (courseId, studentId, grade) => {
  //console.log('updateGrade ', courseId, studentId, grade)
  return {
    type: UPDATE_GRADE,
    data: { courseId, studentId, grade },
  }
}

export const getCourseFullDetails = courseId => {
  //console.log('getCourseFullDetails', courseId)

  return {
    type: GET_COURSE_FULL_DETAILS,
    data: { courseId },
  }
}

export const courseFullDetailsUpdated = data => {
  return {
    type: COURSE_FULL_DETAILS_UPDATED,
    data,
  }
}

export const startCourse = (courseId, course) => {
  //console.log('startCourse', courseId, course)

  return {
    type: START_COURSE,
    data: { courseId, course },
  }
}

export const endCourse = (courseId, course) => {
  //console.log('endCourse', courseId)

  return {
    type: END_COURSE,
    data: { courseId, course },
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/instructorsReducer.js